module.exports = "{{row['estimated_reach']==null || row['estimated_reach']=='' ? \n    'N/A' : row['estimated_reach'] | formatNumber: 2}}\n"